var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApiKeysGraphic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 63.99,
    y: 116.7,
    width: 215.45,
    height: 143.47,
    style: {
      fill: "#ebf2f9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.31 158.3 163.54 154.3 165.25 154.22 165.7 156.95 166.51 156.53 165.9 159.96 164.11 160.29 163.31 158.3",
    style: {
      fill: "#eac5b0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.63 174.13 172.94 173.01 166.69 158.03 163.24 159.16 166.51 179.88 186.33 183.48 185.63 174.13",
    style: {
      fill: "#145566"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,270.73a1.51,1.51,0,0,0-1.36-.59,1.56,1.56,0,0,0-1.15.87,2.67,2.67,0,0,0-.19,1c-.15,1.73-.13,5.83,2.17,6.42a1.7,1.7,0,0,0,2-1.31C56.92,275.79,56.35,272.17,55,270.73Z",
    style: {
      fill: "#1a3151"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.86,244.65l-.12,10.55c.14,4.68-.59,9.39-.45,14.07a12,12,0,0,1,0,3.28c-.27,1.05-1.11,1.23-2,.7-1.16-.71-1-2.36-1.17-3.57-.53-3.31-1.16-6.62-1.72-9.93-.27-1.62.29-3.9.17-5.54l-1.7-8.84Z",
    style: {
      fill: "#eac5b0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.81 227.62 48.4 248 49.38 267.25 56.65 267.09 58.63 213.25 44.53 213.5 43.81 227.62",
    style: {
      fill: "#d1e7f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.45,270.35a1.49,1.49,0,0,0-1.39-.51,1.57,1.57,0,0,0-1.1.93,2.82,2.82,0,0,0-.15,1c-.07,1.73.12,5.84,2.43,6.3a1.75,1.75,0,0,0,2-1.43C67.54,275.3,66.81,271.71,65.45,270.35Z",
    style: {
      fill: "#1a3151"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.61,246.13l.62,10.53c.05,2.92.44,5.83.74,8.73.28,2.7-.15,5.51,1.26,8,.44.77,1.33,1.28,2,.34.48-.72.19-1.92.28-2.74.38-3.33.85-6.66,1.25-10,.2-1.63-.47-3.88-.43-5.52l1.29-8.91Z",
    style: {
      fill: "#eac5b0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.82 226.37 71.41 246.16 68.31 266.17 60.91 266.39 61.23 244.73 57.31 226.78 56 215.02 67.74 213.64 70.82 226.37",
    style: {
      fill: "#d1e7f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.53 173.15 48.88 172.84 41.54 186.49 44.15 199.26 44.61 214.56 62.66 214.8 68.6 213.84 67.02 197.5 67.93 175.67 61.53 173.15",
    style: {
      fill: "#ebb044"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "44.64 208.53 44.06 210.65 47.02 213.06 49.32 212.03 49.93 209.54 48.12 208.84 48.2 208.28 47.71 207.65 44.64 208.53",
    style: {
      fill: "#eac5b0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.89 173.33 33.44 190.29 31.11 197.15 43.75 210.39 47.58 207.82 39.48 196.74 47.21 191.01 48.89 173.33",
    style: {
      fill: "#ebb044"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.05 181.41 67.64 194.59 74.75 196 88.44 184.42 85.39 180.96 73.25 187.76 66.81 175.67 61.05 181.41",
    style: {
      fill: "#ebb044"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.74,162.55C58.83,157,51.51,159.08,50,164c-1,3.22,1.5,7.4,4.84,8.32,0,.13,0,.25,0,.35a10.13,10.13,0,0,0,.14,1.54,17.21,17.21,0,0,0,3.27-.43.48.48,0,0,0,.31-.15c.11-.18-.08-.72-.1-.93s-.05-.48-.07-.72a5.77,5.77,0,0,0,3-4.26A10.71,10.71,0,0,0,60.74,162.55Z",
    style: {
      fill: "#eac5b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,157.54A2.86,2.86,0,0,0,55.3,159a2.45,2.45,0,0,0-.06,1c.28,1.26,1.52,1.19,2.49,1.6a6.4,6.4,0,0,1,2.88,2.48c1,1.66.58,3.8.15,5.63-.14.65-.45,1.61.06,2.18a2.13,2.13,0,0,0,2.29.2c.56-.28,1-.79,1.63-.89s1.52.18,1.82-.42a3.28,3.28,0,0,1,.2-.52c.35-.51,1.24.09,1.75-.27a1,1,0,0,0,.2-1.07,2.64,2.64,0,0,1-.21-1.13,3.66,3.66,0,0,1,.45-.88,1.75,1.75,0,0,0-.24-1.85c-.8-.93-2.34-.75-3.2-1.62a3.82,3.82,0,0,1-.78-1.72,3.24,3.24,0,0,0-.84-1.68c-.59-.52-1.44-.43-2-1.05a11.48,11.48,0,0,0-.95-1.14,7.59,7.59,0,0,0-2.11-.94A2.75,2.75,0,0,0,56,157.54Z",
    style: {
      fill: "#1a3151"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.33,166.38c0,1.83.87,3.8,0,5.41s-3,1.91-4.76,2c-.3,0-4.1.34-4.12.27a12.75,12.75,0,0,0-1.24-3.69,4.09,4.09,0,0,0-3.05-2.12c.37-.06.55-.51.51-.89a5.92,5.92,0,0,0-.35-1.08,2.56,2.56,0,0,1,.66-2.57c1.35-1.25,3.79-.73,4.94-2.17.72-.9.63-2.19,1-3.28.72-2.11,3-2.55,4.76-3.51a8.29,8.29,0,0,1,5.64-1.2c2.6.43,4.54,3.09,3.53,5.58-1.28,3.21-6.44,2.93-7.4,6.18A3.91,3.91,0,0,0,51.33,166.38Z",
    style: {
      fill: "#1a3151"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52.62 173.07 56.55 178.62 58.39 178.47 61.47 172.84 52.62 173.07",
    style: {
      fill: "#d1d6d6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.15,
    y: 43.99,
    width: 1.73,
    height: 64.05,
    transform: "translate(133.83 304.88) rotate(-82.41)",
    style: {
      fill: "#9ea6ad"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.08,
    y: 54.22,
    width: 1.73,
    height: 99.34,
    transform: "translate(24.12 253.28) rotate(-55.86)",
    style: {
      fill: "#9ea6ad"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.55 174.93 273.66 173.4 279.45 174.56 274.19 178.6 267.55 174.93",
    style: {
      fill: "#eac5b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.27,164.26c-1,1.6-.51,3.65-.07,5.4.18.72.49,1.74-.2,2.27a1.82,1.82,0,0,1-2.46-.73,3.83,3.83,0,0,1-.32-1.74c0-2.65-.07-6.36.94-8.82.81-2,4.43-4.78,6.58-2.69a2.79,2.79,0,0,1,.67,1.43,2.21,2.21,0,0,1,.07.92c-.25,1.21-1.47,1.16-2.41,1.55A6.17,6.17,0,0,0,270.27,164.26Z",
    style: {
      fill: "#1a3151"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.56,171.87a5.59,5.59,0,0,1-3-4.08,10.06,10.06,0,0,1,.57-5c1.79-5.33,9-3.39,10.55,1.34C282,168.26,277.33,174.06,272.56,171.87Z",
    style: {
      fill: "#eac5b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.58,166.57c-.15.67,0,1.46-.16,2.16-.22,1.28-1,2.79-.9,4.06a7.91,7.91,0,0,0,4.26-.65c1.22-.58,1.46-1.93,2.08-3.15a17.29,17.29,0,0,0,1.51-3.48,9,9,0,0,0-10.48-11.26c-2.55.44-4.42,3-3.4,5.39,1.1,2.57,4.91,2.8,6.52,5A3.82,3.82,0,0,1,279.58,166.57Z",
    style: {
      fill: "#1a3151"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.57,171.41c-.05.51-.1,1-.16,1.51,0,.24-.22.85-.1,1.06a.4.4,0,0,0,.29.15c.32.07,3.2.59,3.23.37a14.59,14.59,0,0,0,.16-1.75,7.64,7.64,0,0,0,.08-1.7,4.72,4.72,0,0,1-1.74.29c-.58,0-1.16,0-1.75-.05Z",
    style: {
      fill: "#eac5b0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.32 213.85 249.32 213.47 247.32 216.31 248.47 218.32 250.8 218.71 251.67 215.84 251.32 213.85",
    style: {
      fill: "#eac5b0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.13 178.14 262.75 178.55 258.08 198.45 249.31 212.97 251.74 215.78 263.35 204.12 270.13 178.14",
    style: {
      fill: "#9ea6ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.1,272.67a1.74,1.74,0,0,1,1.39-1,1.81,1.81,0,0,1,1.49.68,3.37,3.37,0,0,1,.47,1c.58,1.86,1.57,6.37-.87,7.55a2,2,0,0,1-2.6-1C266.23,278.67,266,274.56,267.1,272.67Z",
    style: {
      fill: "#1a3151"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.52,244l-.32,11.83c.08,5.26-.84,10.54-.76,15.79a13,13,0,0,1,0,3.69c-.32,1.17-1.3,1.36-2.29.75-1.33-.81-1.08-2.67-1.29-4-.55-3.74-1.21-7.45-1.8-11.18-.28-1.83.4-4.37.29-6.22l-1.8-9.94Z",
    style: {
      fill: "#eac5b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.47,273.14a1.68,1.68,0,0,1,2.89.18,3.19,3.19,0,0,1,.28,1.09c.25,1.93.45,6.54-2.16,7.32a2,2,0,0,1-2.4-1.37C273.57,278.91,274.05,274.82,275.47,273.14Z",
    style: {
      fill: "#1a3151"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.19,243.93l.68,11.82c.08,5.26,1.16,10.5,1.24,15.76a13.32,13.32,0,0,0,.12,3.68c.36,1.16,1.35,1.33,2.32.69,1.3-.86,1-2.7,1.16-4.06.44-3.75,1-7.48,1.46-11.23.23-1.83-.53-4.36-.48-6.21l1.51-10Z",
    style: {
      fill: "#eac5b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.2,173.57l-5,2.65-5.65-2-5.79,4.37s.6,18.22.38,25-.67,12.23-1.25,22.1c-.65,10.86,2.12,23.92,2.12,23.92l22.54-.34s4.59-24.72,2.23-31.13-.95-12.78-1-18-2.29-22.81-2.29-22.81Z",
    style: {
      fill: "#9ea6ad"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.47 157.93 302.84 158.72 305.75 155.41 304.7 152.68 301.92 151.83 300.38 155.36 300.47 157.93",
    style: {
      fill: "#eac5b0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.59 184.23 296.53 179.1 304.54 157.81 299.79 156.63 290.38 172.81 280.65 174.87 280.59 184.23",
    style: {
      fill: "#9ea6ad"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.68,
    y: 164.55,
    width: 93.16,
    height: 1.73,
    transform: "translate(-76.01 87.72) rotate(-34.73)",
    style: {
      fill: "#9ea6ad"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.93,
    y: 67.45,
    width: 1.73,
    height: 93.55,
    transform: "translate(-49.4 139.68) rotate(-58.19)",
    style: {
      fill: "#9ea6ad"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.06,
    y: 104.47,
    width: 98.05,
    height: 1.73,
    transform: "translate(-24.93 147.65) rotate(-43.18)",
    style: {
      fill: "#9ea6ad"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.77,
    y: 113.24,
    width: 1.73,
    height: 112.88,
    transform: "translate(-57.86 232.63) rotate(-56.92)",
    style: {
      fill: "#9ea6ad"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.5,
    y: 133.42,
    width: 155.01,
    height: 1.73,
    transform: "translate(-4.26 7.18) rotate(-1.87)",
    style: {
      fill: "#9ea6ad"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.27,
    cy: 131.86,
    r: 46.74,
    style: {
      fill: "#b5d6ca"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.66,
    cy: 87.62,
    r: 18.61,
    style: {
      fill: "#ebb044"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.29,
    cy: 191.94,
    r: 19.64,
    transform: "translate(-134.98 213.33) rotate(-76.72)",
    style: {
      fill: "#94b4d6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209.27,
    cy: 73.45,
    r: 21.71,
    style: {
      fill: "#3ababa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.93,
    cy: 197.97,
    r: 23.66,
    transform: "translate(-71.76 222.69) rotate(-45)",
    style: {
      fill: "#3ababa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.06,
    cy: 131.77,
    r: 26.83,
    transform: "translate(-7.63 245.11) rotate(-45)",
    style: {
      fill: "#94b4d6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 272.76,
    cy: 80.24,
    r: 13.25,
    transform: "translate(94.25 301.53) rotate(-67.5)",
    style: {
      fill: "#ebb044"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.07 215.98 184.07 221.74 176.39 246.72 178.31 272.65 173.51 273.61 165.82 241.91 166.12 232.59 169.67 213.57 184.07 215.98",
    style: {
      fill: "#1a3151"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.98 222.8 185.7 275.63 189.21 275.63 191.43 246.82 196.23 218 177.98 222.8",
    style: {
      fill: "#1a3151"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.14 273.12 170.47 277 171.53 278.97 179.1 275.34 177.7 272.46 174.14 273.12",
    style: {
      fill: "#3ababa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.76 274.89 181.25 277.73 181.78 279.9 190.01 278.28 189.38 275.14 185.76 274.89",
    style: {
      fill: "#3ababa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.12,158.49c2.14,2.26,6,2.34,7.85,4.87a6,6,0,0,1,.27,5.9,5,5,0,0,1-1.85,2.18,4.82,4.82,0,0,1-1.76.59,7,7,0,0,1-2.45-.09,13.44,13.44,0,0,0-.21,2.2c-1.43-.56-3.32-.09-4.75-.65.32-.83,1.11-2.68,1.43-3.5a6.59,6.59,0,0,1-.82-1,7.44,7.44,0,0,1-.14-7.61A14.56,14.56,0,0,1,184.12,158.49Z",
    style: {
      fill: "#eac5b0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.07 159.71 191.95 165.36 188.37 172.04 191.83 172.28 198.91 162.46 189.07 153.08 182.4 151.66 180.26 154.38 181.75 160.54 184.07 159.71",
    style: {
      fill: "#1a3151"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.2 185.44 88.23 183.51 85.88 180.5 83.4 181 82.26 183.28 83.87 184.37 83.67 184.9 84.01 185.63 87.2 185.44",
    style: {
      fill: "#eac5b0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.13 166.41 152.63 162.56 154.24 161.85 155.85 164.25 156.46 163.56 157.34 167.01 155.76 167.98 154.13 166.41",
    style: {
      fill: "#eac5b0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.32 178.89 171.36 180.48 157.44 165.74 154.4 167.82 165.59 187.3 188.32 191.08 188.32 178.89",
    style: {
      fill: "#145566"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.28,173.15,186.72,172a77.14,77.14,0,0,1,13.69,26.4c4.48,15.68-5.48,37.67-5.48,37.67s-30.91-6.31-36-7.31l10-31.35Z",
    style: {
      fill: "#145566"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiKeysGraphic);
export default __webpack_public_path__ + "static/media/api_keys_graphic.d480cac8157e70b7574925974dd7cdd1.svg";
export { ForwardRef as ReactComponent };